import { ThemeUICSSObject } from '@apia/theme';
import list from './list';
import floating from './floating';
/* IMPORT HERE */

const notifications: ThemeUICSSObject = {
  list,
  floating,
  /* PREPEND HERE */
};

export default notifications;
